import { instance as Toast } from "@/plugins/toast";

// 经纬度转换
function translate(point, cb) {
	let bPoint = new BMap.Point(point.longitude, point.latitude);
	let convertor = new BMap.Convertor();
	convertor.translate([bPoint], 1, 5, data => {
		if (data.status == 0) {
			cb && cb(data.points[0]);
		} else {
			Toast.show("坐标转换错误");
		}
	});
}

// 获取当前地址
function getAddress(point, cb) {
	let bPoint = new BMap.Point(point.longitude, point.latitude);
	let gc = new BMap.Geocoder();
	gc.getLocation(bPoint, function(res) {
		cb && cb(res);
	});
}

export default {
	translate,
	getAddress,
};
